// extracted by mini-css-extract-plugin
export default {"periodLabel":"_1jieY","matchPeriodLabel":"_2cWfm"};